<fuse-card class="flex h-full flex-col">
  <!-- Header -->
  <div class="flex items-center gap-2 border-b px-4 py-3">
    <span class="flex-1 text-base font-semibold text-gray-900">Financial Overview</span>
    <a
      routerLink="/reports/financial/collection-report"
      [queryParams]="{ _ref: 'dashboard' }"
      class="rounded border border-transparent px-2 py-0.5 text-sm text-gray-400 transition hover:border-gray-200 hover:text-primary"
      >Full report</a
    >
  </div>

  @if (dataLoader) {
    <div class="flex flex-1 items-center justify-center">
      <mat-spinner diameter="28" color="primary"></mat-spinner>
    </div>
  }

  @if (dataList && !dataLoader) {
    <div class="flex flex-1 flex-col gap-2 px-4 py-2">
      <!-- Recovery Rate Banner -->
      <div class="rounded-xl from-green-50 to-emerald-50 px-3 py-1 ring-1 ring-green-100">
        <div class="mb-2 flex items-center justify-between">
          <span class="text-xs font-semibold uppercase tracking-widest text-green-700">Recovery Rate</span>
          <span class="text-2xl font-extrabold text-green-600">{{ recovery?.rate || '0.0' }}%</span>
        </div>
        <div class="h-2 w-full overflow-hidden rounded-full bg-green-100">
          <div class="h-full rounded-full bg-green-500 transition-all duration-700" [style.width.%]="recovery?.rate || 0"></div>
        </div>
      </div>

      <!-- 4 Metric blocks -->
      <div class="grid flex-1 grid-cols-2 gap-2">
        <!-- Opening -->
        <div class="flex flex-col justify-evenly rounded-xl border border-gray-100 bg-gray-50 px-3 py-2">
          <div class="mb-1 flex items-center gap-1.5">
            <div class="h-1.5 w-1.5 rounded-full bg-gray-400"></div>
            <span class="text-[10px] font-semibold uppercase tracking-wide text-gray-400">Opening</span>
          </div>
          <div class="truncate text-sm font-bold text-gray-700" [innerHTML]="recovery?.opening_balanace | amount"></div>
        </div>

        <!-- Invoices -->
        <div class="flex flex-col justify-evenly rounded-xl border border-blue-100 bg-blue-50 px-3 py-2">
          <div class="mb-1 flex items-center gap-1.5">
            <div class="h-1.5 w-1.5 rounded-full bg-blue-400"></div>
            <span class="text-[10px] font-semibold uppercase tracking-wide text-blue-400">Invoices</span>
          </div>
          <div class="truncate text-sm font-bold text-blue-700" [innerHTML]="recovery?.charge | amount"></div>
        </div>

        <!-- Collection -->
        <div class="flex flex-col justify-evenly rounded-xl border border-green-100 bg-green-50 px-3 py-2">
          <div class="mb-1 flex items-center gap-1.5">
            <div class="h-1.5 w-1.5 rounded-full bg-green-500"></div>
            <span class="text-[10px] font-semibold uppercase tracking-wide text-green-600">Collection</span>
          </div>
          <div class="truncate text-sm font-bold text-green-700" [innerHTML]="totalPayments | amount"></div>
        </div>

        <!-- Receivables -->
        <div class="flex flex-col justify-evenly rounded-xl border border-red-100 bg-red-50 px-3 py-2">
          <div class="mb-1 flex items-center gap-1.5">
            <div class="h-1.5 w-1.5 rounded-full bg-red-400"></div>
            <span class="text-[10px] font-semibold uppercase tracking-wide text-red-400">Receivables</span>
          </div>
          <div class="truncate text-sm font-bold text-red-700" [innerHTML]="recovery?.closing_balanace | amount"></div>
        </div>
      </div>
    </div>
  }

  @if (!dataLoader && !dataList && !error) {
    <div class="flex flex-1 flex-col items-center justify-center gap-2 text-gray-400">
      <mat-icon fontIcon="account_balance" class="opacity-40 icon-size-8"></mat-icon>
      <span class="text-sm font-medium">No financial data</span>
    </div>
  }
</fuse-card>
